import {cloneDeep} from 'lodash/fp'
import {value} from './changeFunc'

/**
 * interface formDataProp [
 *  [
 *    {
 *      id: String,
 *      type: String,
 *      ...properties
 *    }
 *  ],
 *  ...elements
 * ]
 */

/**
 * interface sendData {
 *  property: value,
 *  ...properties
 * }
 */

/**
 * interface typeRenderProp {
 *  type: {component: React.Component, ...properties},
 *  ...properties
 * }
 */

/**
 * Converts initial formData prop to more usable format
 * (formData: formDataProp) => sendData
 */
const convertFormDataToSendData = formData => {
  return formData.reduce((acc, value) => {
    let stepData = value.reduce((acc, value) => {
      return {...acc, [value.id]: value.value}
    }, {})

    return {...acc, ...stepData}
  }, {})
}

/**
 * Checks formData to have id and type fields
 * (formData: formDataProp) => Boolean
 */
const formDataHasIdAndType = formData => {
  for(let step = 0; step < formData.length; step++) {
    for(let field = 0; field < formData[step].length; field++) {
      if(!(formData[step][field].id && typeof formData[step][field].id === 'string')) {
        return false
      }
      if(!(formData[step][field].type && typeof formData[step][field].type === 'string')) {
        return false
      }
    }
  }
  return true
}

/**
 * Applies default values to needed fiels if they not present
 * (formData: formDataProp) => formDataProp
 */
const applyDefaultsToFormData = formData => {
  return formData.map(step => {
    return step.map(field => {

      if(!field.value) {
        field.value = ''
      }

      if(!field.rules) {
        field.rules = []
      }

      if(!field.errorMessage) {
        field.errorMessage = ''
      }

      if(!field.error) {
        field.error = false
      }

      return field
    })
  })
}

/**
 * Checks typeRender to have component field
 * (typeRender: typeRenderProp) => Boolean
 */
const typeRenderHasComponent = typeRender => {
  for(let type in typeRender) {
    if(!typeRender[type].hasOwnProperty('component')) {
      return false
    }
  }
  return true
}

/**
 * Applies default values to needed fields if they not present
 * (typeRender: typeRenderProp) => typeRenderProp
 */
const applyDefaultsToTypeRender = typeRender => {
  const newTypeRender = cloneDeep(typeRender)

  for(let type in newTypeRender) {
    if(!newTypeRender[type].hasOwnProperty('onChange')) {
      newTypeRender[type].onChange = value
    }
  }

  return newTypeRender
}


export {
  convertFormDataToSendData,
  formDataHasIdAndType,
  applyDefaultsToFormData,
  typeRenderHasComponent,
  applyDefaultsToTypeRender
}


// WEBPACK FOOTER //
// ./src/formWizard/utils.js